import script from "./TokenCounter.vue?vue&type=script&setup=true&lang=js"
export * from "./TokenCounter.vue?vue&type=script&setup=true&lang=js"

import "./TokenCounter.vue?vue&type=style&index=0&id=5452809e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5452809e"]])

export default __exports__